import { PhoneNumber as NxtPhoneNumber } from '@nxtpeople/nxt-vue-library';

export interface PhoneNumber extends NxtPhoneNumber {
   international_format: string;
}

export interface PhoneNumberType {
   country_code: string;
   id: string;
   prefix: string;
}

export const phoneNumberTypes: Array<PhoneNumberType> = [
   {
      country_code: 'AF',
      id: '93',
      prefix: '+93',
   },
   {
      country_code: 'AL',
      id: '355',
      prefix: '+355',
   },
   {
      country_code: 'DZ',
      id: '213',
      prefix: '+213',
   },
   {
      country_code: 'AS',
      id: '1684',
      prefix: '+1684',
   },
   {
      country_code: 'AD',
      id: '376',
      prefix: '+376',
   },
   {
      country_code: 'AO',
      id: '244',
      prefix: '+244',
   },
   {
      country_code: 'AI',
      id: '1264',
      prefix: '+1264',
   },
   {
      country_code: 'AG',
      id: '1268',
      prefix: '+1268',
   },
   {
      country_code: 'AR',
      id: '54',
      prefix: '+54',
   },
   {
      country_code: 'AM',
      id: '374',
      prefix: '+374',
   },
   {
      country_code: 'AW',
      id: '297',
      prefix: '+297',
   },
   {
      country_code: 'AU',
      id: '61',
      prefix: '+61',
   },
   {
      country_code: 'AT',
      id: '43',
      prefix: '+43',
   },
   {
      country_code: 'AZ',
      id: '994',
      prefix: '+994',
   },
   {
      country_code: 'BS',
      id: '1242',
      prefix: '+1242',
   },
   {
      country_code: 'BH',
      id: '973',
      prefix: '+973',
   },
   {
      country_code: 'BD',
      id: '880',
      prefix: '+880',
   },
   {
      country_code: 'BB',
      id: '1246',
      prefix: '+1246',
   },
   {
      country_code: 'BY',
      id: '375',
      prefix: '+375',
   },
   {
      country_code: 'BE',
      id: '32',
      prefix: '+32',
   },
   {
      country_code: 'BZ',
      id: '501',
      prefix: '+501',
   },
   {
      country_code: 'BJ',
      id: '229',
      prefix: '+229',
   },
   {
      country_code: 'BM',
      id: '1441',
      prefix: '+1441',
   },
   {
      country_code: 'BT',
      id: '975',
      prefix: '+975',
   },
   {
      country_code: 'BO',
      id: '591',
      prefix: '+591',
   },
   {
      country_code: 'BA',
      id: '387',
      prefix: '+387',
   },
   {
      country_code: 'BW',
      id: '267',
      prefix: '+267',
   },
   {
      country_code: 'BR',
      id: '55',
      prefix: '+55',
   },
   {
      country_code: 'IO',
      id: '246',
      prefix: '+246',
   },
   {
      country_code: 'VG',
      id: '1284',
      prefix: '+1284',
   },
   {
      country_code: 'BN',
      id: '673',
      prefix: '+673',
   },
   {
      country_code: 'BG',
      id: '359',
      prefix: '+359',
   },
   {
      country_code: 'BF',
      id: '226',
      prefix: '+226',
   },
   {
      country_code: 'BI',
      id: '257',
      prefix: '+257',
   },
   {
      country_code: 'KH',
      id: '855',
      prefix: '+855',
   },
   {
      country_code: 'CM',
      id: '237',
      prefix: '+237',
   },
   {
      country_code: 'CA',
      id: '1',
      prefix: '+1',
   },
   {
      country_code: 'CV',
      id: '238',
      prefix: '+238',
   },
   {
      country_code: 'BQ',
      id: '599',
      prefix: '+599',
   },
   {
      country_code: 'KY',
      id: '1345',
      prefix: '+1345',
   },
   {
      country_code: 'CF',
      id: '236',
      prefix: '+236',
   },
   {
      country_code: 'TD',
      id: '235',
      prefix: '+235',
   },
   {
      country_code: 'CL',
      id: '56',
      prefix: '+56',
   },
   {
      country_code: 'CN',
      id: '86',
      prefix: '+86',
   },
   {
      country_code: 'CX',
      id: '61',
      prefix: '+61',
   },
   {
      country_code: 'CC',
      id: '61',
      prefix: '+61',
   },
   {
      country_code: 'CO',
      id: '57',
      prefix: '+57',
   },
   {
      country_code: 'KM',
      id: '269',
      prefix: '+269',
   },
   {
      country_code: 'CD',
      id: '243',
      prefix: '+243',
   },
   {
      country_code: 'CG',
      id: '242',
      prefix: '+242',
   },
   {
      country_code: 'CK',
      id: '682',
      prefix: '+682',
   },
   {
      country_code: 'CR',
      id: '506',
      prefix: '+506',
   },
   {
      country_code: 'CI',
      id: '225',
      prefix: '+225',
   },
   {
      country_code: 'HR',
      id: '385',
      prefix: '+385',
   },
   {
      country_code: 'CU',
      id: '53',
      prefix: '+53',
   },
   {
      country_code: 'CW',
      id: '599',
      prefix: '+599',
   },
   {
      country_code: 'CY',
      id: '357',
      prefix: '+357',
   },
   {
      country_code: 'CZ',
      id: '420',
      prefix: '+420',
   },
   {
      country_code: 'DK',
      id: '45',
      prefix: '+45',
   },
   {
      country_code: 'DJ',
      id: '253',
      prefix: '+253',
   },
   {
      country_code: 'DM',
      id: '1767',
      prefix: '+1767',
   },
   {
      country_code: 'DO',
      id: '1',
      prefix: '+1',
   },
   {
      country_code: 'EC',
      id: '593',
      prefix: '+593',
   },
   {
      country_code: 'EG',
      id: '20',
      prefix: '+20',
   },
   {
      country_code: 'SV',
      id: '503',
      prefix: '+503',
   },
   {
      country_code: 'GQ',
      id: '240',
      prefix: '+240',
   },
   {
      country_code: 'ER',
      id: '291',
      prefix: '+291',
   },
   {
      country_code: 'EE',
      id: '372',
      prefix: '+372',
   },
   {
      country_code: 'ET',
      id: '251',
      prefix: '+251',
   },
   {
      country_code: 'FK',
      id: '500',
      prefix: '+500',
   },
   {
      country_code: 'FO',
      id: '298',
      prefix: '+298',
   },
   {
      country_code: 'FJ',
      id: '679',
      prefix: '+679',
   },
   {
      country_code: 'FI',
      id: '358',
      prefix: '+358',
   },
   {
      country_code: 'FR',
      id: '33',
      prefix: '+33',
   },
   {
      country_code: 'GF',
      id: '594',
      prefix: '+594',
   },
   {
      country_code: 'PF',
      id: '689',
      prefix: '+689',
   },
   {
      country_code: 'GA',
      id: '241',
      prefix: '+241',
   },
   {
      country_code: 'GM',
      id: '220',
      prefix: '+220',
   },
   {
      country_code: 'GE',
      id: '995',
      prefix: '+995',
   },
   {
      country_code: 'DE',
      id: '49',
      prefix: '+49',
   },
   {
      country_code: 'GH',
      id: '233',
      prefix: '+233',
   },
   {
      country_code: 'GI',
      id: '350',
      prefix: '+350',
   },
   {
      country_code: 'GR',
      id: '30',
      prefix: '+30',
   },
   {
      country_code: 'GL',
      id: '299',
      prefix: '+299',
   },
   {
      country_code: 'GD',
      id: '1473',
      prefix: '+1473',
   },
   {
      country_code: 'GP',
      id: '590',
      prefix: '+590',
   },
   {
      country_code: 'GU',
      id: '1671',
      prefix: '+1671',
   },
   {
      country_code: 'GT',
      id: '502',
      prefix: '+502',
   },
   {
      country_code: 'GG',
      id: '44',
      prefix: '+44',
   },
   {
      country_code: 'GN',
      id: '224',
      prefix: '+224',
   },
   {
      country_code: 'GW',
      id: '245',
      prefix: '+245',
   },
   {
      country_code: 'GY',
      id: '592',
      prefix: '+592',
   },
   {
      country_code: 'HT',
      id: '509',
      prefix: '+509',
   },
   {
      country_code: 'HN',
      id: '504',
      prefix: '+504',
   },
   {
      country_code: 'HK',
      id: '852',
      prefix: '+852',
   },
   {
      country_code: 'HU',
      id: '36',
      prefix: '+36',
   },
   {
      country_code: 'IS',
      id: '354',
      prefix: '+354',
   },
   {
      country_code: 'IN',
      id: '91',
      prefix: '+91',
   },
   {
      country_code: 'ID',
      id: '62',
      prefix: '+62',
   },
   {
      country_code: 'IR',
      id: '98',
      prefix: '+98',
   },
   {
      country_code: 'IQ',
      id: '964',
      prefix: '+964',
   },
   {
      country_code: 'IE',
      id: '353',
      prefix: '+353',
   },
   {
      country_code: 'IM',
      id: '44',
      prefix: '+44',
   },
   {
      country_code: 'IL',
      id: '972',
      prefix: '+972',
   },
   {
      country_code: 'IT',
      id: '39',
      prefix: '+39',
   },
   {
      country_code: 'JM',
      id: '1876',
      prefix: '+1876',
   },
   {
      country_code: 'JP',
      id: '81',
      prefix: '+81',
   },
   {
      country_code: 'JE',
      id: '44',
      prefix: '+44',
   },
   {
      country_code: 'JO',
      id: '962',
      prefix: '+962',
   },
   {
      country_code: 'KZ',
      id: '7',
      prefix: '+7',
   },
   {
      country_code: 'KE',
      id: '254',
      prefix: '+254',
   },
   {
      country_code: 'KI',
      id: '686',
      prefix: '+686',
   },
   {
      country_code: 'XK',
      id: '383',
      prefix: '+383',
   },
   {
      country_code: 'KW',
      id: '965',
      prefix: '+965',
   },
   {
      country_code: 'KG',
      id: '996',
      prefix: '+996',
   },
   {
      country_code: 'LA',
      id: '856',
      prefix: '+856',
   },
   {
      country_code: 'LV',
      id: '371',
      prefix: '+371',
   },
   {
      country_code: 'LB',
      id: '961',
      prefix: '+961',
   },
   {
      country_code: 'LS',
      id: '266',
      prefix: '+266',
   },
   {
      country_code: 'LR',
      id: '231',
      prefix: '+231',
   },
   {
      country_code: 'LY',
      id: '218',
      prefix: '+218',
   },
   {
      country_code: 'LI',
      id: '423',
      prefix: '+423',
   },
   {
      country_code: 'LT',
      id: '370',
      prefix: '+370',
   },
   {
      country_code: 'LU',
      id: '352',
      prefix: '+352',
   },
   {
      country_code: 'MO',
      id: '853',
      prefix: '+853',
   },
   {
      country_code: 'MK',
      id: '389',
      prefix: '+389',
   },
   {
      country_code: 'MG',
      id: '261',
      prefix: '+261',
   },
   {
      country_code: 'MW',
      id: '265',
      prefix: '+265',
   },
   {
      country_code: 'MY',
      id: '60',
      prefix: '+60',
   },
   {
      country_code: 'MV',
      id: '960',
      prefix: '+960',
   },
   {
      country_code: 'ML',
      id: '223',
      prefix: '+223',
   },
   {
      country_code: 'MT',
      id: '356',
      prefix: '+356',
   },
   {
      country_code: 'MH',
      id: '692',
      prefix: '+692',
   },
   {
      country_code: 'MQ',
      id: '596',
      prefix: '+596',
   },
   {
      country_code: 'MR',
      id: '222',
      prefix: '+222',
   },
   {
      country_code: 'MU',
      id: '230',
      prefix: '+230',
   },
   {
      country_code: 'YT',
      id: '262',
      prefix: '+262',
   },
   {
      country_code: 'MX',
      id: '52',
      prefix: '+52',
   },
   {
      country_code: 'FM',
      id: '691',
      prefix: '+691',
   },
   {
      country_code: 'MD',
      id: '373',
      prefix: '+373',
   },
   {
      country_code: 'MC',
      id: '377',
      prefix: '+377',
   },
   {
      country_code: 'MN',
      id: '976',
      prefix: '+976',
   },
   {
      country_code: 'ME',
      id: '382',
      prefix: '+382',
   },
   {
      country_code: 'MS',
      id: '1664',
      prefix: '+1664',
   },
   {
      country_code: 'MA',
      id: '212',
      prefix: '+212',
   },
   {
      country_code: 'MZ',
      id: '258',
      prefix: '+258',
   },
   {
      country_code: 'MM',
      id: '95',
      prefix: '+95',
   },
   {
      country_code: 'NA',
      id: '264',
      prefix: '+264',
   },
   {
      country_code: 'NR',
      id: '674',
      prefix: '+674',
   },
   {
      country_code: 'NP',
      id: '977',
      prefix: '+977',
   },
   {
      country_code: 'NL',
      id: '31',
      prefix: '+31',
   },
   {
      country_code: 'NC',
      id: '687',
      prefix: '+687',
   },
   {
      country_code: 'NZ',
      id: '64',
      prefix: '+64',
   },
   {
      country_code: 'NI',
      id: '505',
      prefix: '+505',
   },
   {
      country_code: 'NE',
      id: '227',
      prefix: '+227',
   },
   {
      country_code: 'NG',
      id: '234',
      prefix: '+234',
   },
   {
      country_code: 'NU',
      id: '683',
      prefix: '+683',
   },
   {
      country_code: 'NF',
      id: '672',
      prefix: '+672',
   },
   {
      country_code: 'KP',
      id: '850',
      prefix: '+850',
   },
   {
      country_code: 'MP',
      id: '1670',
      prefix: '+1670',
   },
   {
      country_code: 'NO',
      id: '47',
      prefix: '+47',
   },
   {
      country_code: 'OM',
      id: '968',
      prefix: '+968',
   },
   {
      country_code: 'PK',
      id: '92',
      prefix: '+92',
   },
   {
      country_code: 'PW',
      id: '680',
      prefix: '+680',
   },
   {
      country_code: 'PS',
      id: '970',
      prefix: '+970',
   },
   {
      country_code: 'PA',
      id: '507',
      prefix: '+507',
   },
   {
      country_code: 'PG',
      id: '675',
      prefix: '+675',
   },
   {
      country_code: 'PY',
      id: '595',
      prefix: '+595',
   },
   {
      country_code: 'PE',
      id: '51',
      prefix: '+51',
   },
   {
      country_code: 'PH',
      id: '63',
      prefix: '+63',
   },
   {
      country_code: 'PL',
      id: '48',
      prefix: '+48',
   },
   {
      country_code: 'PT',
      id: '351',
      prefix: '+351',
   },
   {
      country_code: 'PR',
      id: '1',
      prefix: '+1',
   },
   {
      country_code: 'QA',
      id: '974',
      prefix: '+974',
   },
   {
      country_code: 'RE',
      id: '262',
      prefix: '+262',
   },
   {
      country_code: 'RO',
      id: '40',
      prefix: '+40',
   },
   {
      country_code: 'RU',
      id: '7',
      prefix: '+7',
   },
   {
      country_code: 'RW',
      id: '250',
      prefix: '+250',
   },
   {
      country_code: 'BL',
      id: '590',
      prefix: '+590',
   },
   {
      country_code: 'SH',
      id: '290',
      prefix: '+290',
   },
   {
      country_code: 'KN',
      id: '1869',
      prefix: '+1869',
   },
   {
      country_code: 'LC',
      id: '1758',
      prefix: '+1758',
   },
   {
      country_code: 'MF',
      id: '590',
      prefix: '+590',
   },
   {
      country_code: 'PM',
      id: '508',
      prefix: '+508',
   },
   {
      country_code: 'VC',
      id: '1784',
      prefix: '+1784',
   },
   {
      country_code: 'WS',
      id: '685',
      prefix: '+685',
   },
   {
      country_code: 'SM',
      id: '378',
      prefix: '+378',
   },
   {
      country_code: 'ST',
      id: '239',
      prefix: '+239',
   },
   {
      country_code: 'SA',
      id: '966',
      prefix: '+966',
   },
   {
      country_code: 'SN',
      id: '221',
      prefix: '+221',
   },
   {
      country_code: 'RS',
      id: '381',
      prefix: '+381',
   },
   {
      country_code: 'SC',
      id: '248',
      prefix: '+248',
   },
   {
      country_code: 'SL',
      id: '232',
      prefix: '+232',
   },
   {
      country_code: 'SG',
      id: '65',
      prefix: '+65',
   },
   {
      country_code: 'SX',
      id: '1721',
      prefix: '+1721',
   },
   {
      country_code: 'SK',
      id: '421',
      prefix: '+421',
   },
   {
      country_code: 'SI',
      id: '386',
      prefix: '+386',
   },
   {
      country_code: 'SB',
      id: '677',
      prefix: '+677',
   },
   {
      country_code: 'SO',
      id: '252',
      prefix: '+252',
   },
   {
      country_code: 'ZA',
      id: '27',
      prefix: '+27',
   },
   {
      country_code: 'KR',
      id: '82',
      prefix: '+82',
   },
   {
      country_code: 'SS',
      id: '211',
      prefix: '+211',
   },
   {
      country_code: 'ES',
      id: '34',
      prefix: '+34',
   },
   {
      country_code: 'LK',
      id: '94',
      prefix: '+94',
   },
   {
      country_code: 'SD',
      id: '249',
      prefix: '+249',
   },
   {
      country_code: 'SR',
      id: '597',
      prefix: '+597',
   },
   {
      country_code: 'SJ',
      id: '47',
      prefix: '+47',
   },
   {
      country_code: 'SZ',
      id: '268',
      prefix: '+268',
   },
   {
      country_code: 'SE',
      id: '46',
      prefix: '+46',
   },
   {
      country_code: 'CH',
      id: '41',
      prefix: '+41',
   },
   {
      country_code: 'SY',
      id: '963',
      prefix: '+963',
   },
   {
      country_code: 'TW',
      id: '886',
      prefix: '+886',
   },
   {
      country_code: 'TJ',
      id: '992',
      prefix: '+992',
   },
   {
      country_code: 'TZ',
      id: '255',
      prefix: '+255',
   },
   {
      country_code: 'TH',
      id: '66',
      prefix: '+66',
   },
   {
      country_code: 'TL',
      id: '670',
      prefix: '+670',
   },
   {
      country_code: 'TG',
      id: '228',
      prefix: '+228',
   },
   {
      country_code: 'TK',
      id: '690',
      prefix: '+690',
   },
   {
      country_code: 'TO',
      id: '676',
      prefix: '+676',
   },
   {
      country_code: 'TT',
      id: '1868',
      prefix: '+1868',
   },
   {
      country_code: 'TN',
      id: '216',
      prefix: '+216',
   },
   {
      country_code: 'TR',
      id: '90',
      prefix: '+90',
   },
   {
      country_code: 'TM',
      id: '993',
      prefix: '+993',
   },
   {
      country_code: 'TC',
      id: '1649',
      prefix: '+1649',
   },
   {
      country_code: 'TV',
      id: '688',
      prefix: '+688',
   },
   {
      country_code: 'VI',
      id: '1340',
      prefix: '+1340',
   },
   {
      country_code: 'UG',
      id: '256',
      prefix: '+256',
   },
   {
      country_code: 'UA',
      id: '380',
      prefix: '+380',
   },
   {
      country_code: 'AE',
      id: '971',
      prefix: '+971',
   },
   {
      country_code: 'GB',
      id: '44',
      prefix: '+44',
   },
   {
      country_code: 'US',
      id: '1',
      prefix: '+1',
   },
   {
      country_code: 'UY',
      id: '598',
      prefix: '+598',
   },
   {
      country_code: 'UZ',
      id: '998',
      prefix: '+998',
   },
   {
      country_code: 'VU',
      id: '678',
      prefix: '+678',
   },
   {
      country_code: 'VA',
      id: '39',
      prefix: '+39',
   },
   {
      country_code: 'VE',
      id: '58',
      prefix: '+58',
   },
   {
      country_code: 'VN',
      id: '84',
      prefix: '+84',
   },
   {
      country_code: 'WF',
      id: '681',
      prefix: '+681',
   },
   {
      country_code: 'EH',
      id: '212',
      prefix: '+212',
   },
   {
      country_code: 'YE',
      id: '967',
      prefix: '+967',
   },
   {
      country_code: 'ZM',
      id: '260',
      prefix: '+260',
   },
   {
      country_code: 'ZW',
      id: '263',
      prefix: '+263',
   },
   {
      country_code: 'AX',
      id: '358',
      prefix: '+358',
   },
];
